module.exports = __webpack_public_path__ + "img/bussiness_mobile_zotl1.909ecaf3.png";